import { createContext, useContext } from 'react';

interface SearchPaletteContextValue {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
}

export const SearchPaletteContext = createContext<SearchPaletteContextValue | null>(null);

export function useSearchPalette(): SearchPaletteContextValue {
  const ctx = useContext(SearchPaletteContext);
  if (!ctx) {
    throw new Error('useSearchPalette must be used inside <SearchPaletteProvider>');
  }
  return ctx;
}
